import { useTypedTranslation } from '~/common/hooks/useTypedTranslation'
import { cn } from '../lib/utils'
import Typography from './ui/typography'

export enum NoAccessObjectType {
  TABLE = 'TABLE',
  PIVOT_TABLE = 'PIVOT_TABLE',
}

interface NoAccessProps {
  objectType: NoAccessObjectType
  className?: string
}

export function NoAccess({ objectType, className }: NoAccessProps) {
  const { t } = useTypedTranslation()
  return (
    <div className={cn('px-8 py-4', className)}>
      <div className="flex h-full min-h-full flex-col items-center justify-center border border-dashed border-gray-4 bg-gray-1 px-4 py-12 sm:px-6 lg:px-8">
        <div className="w-full max-w-md space-y-8 text-center">
          <Typography variant="body2" className="text-center">
            {t(`no_access.object_types.${objectType}.title`)}
          </Typography>
          <Typography variant="body1" className="text-center text-gray-8">
            {t(`no_access.object_types.${objectType}.description`)}
          </Typography>
        </div>
      </div>
    </div>
  )
}
